import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import axios from "axios";
import BtnLoader from "Components/Common/Loader/BtnLoader";
import { loadDecrypted } from "Common Usage/localStorageUtils"; // <-- added

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
};

const ConfirmDeleteModal = ({ visible, onClose, avatar, fetchAllAvatars }) => {
  const [isLoading, setIsLoading] = useState(false);

  const deleteAvatar = () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/avatar/delete-avatar/${avatar?._id}`,
      headers: {},
      data: "",
    };

    setIsLoading(true);
    axios
      .request(config)
      .then(async (response) => {
        // ─────────────────────────────────────────────────────────
        // Create staff activity log for avatar deletion
        // ─────────────────────────────────────────────────────────
        try {
          const staffData = loadDecrypted("HeartConnect-StaffData");
          const staffId = staffData?._id || staffData?.id || "";
          const staffName = staffData?.fullName || staffData?.name || "Unknown";

          if (staffId) {
            await axios.post(
              `${process.env.REACT_APP_API_URL}/staffs-activity-log/create-staffs-activity`,
              {
                staff: staffId,
                action: "DELETE_AVATAR",
                description: `Staff ${staffName} deleted avatar (ID: ${avatar?._id}, gender: ${avatar?.gender}, url: ${avatar?.avatarUrl})`,
              },
              { headers: { "Content-Type": "application/json" } }
            );
          }
        } catch (logErr) {
          console.error("Failed to create staff activity log:", logErr);
        }
        // ─────────────────────────────────────────────────────────

        setIsLoading(false);
        fetchAllAvatars();
        onClose();
      })
      .catch((error) => {
        setIsLoading(false);
        fetchAllAvatars();
        onClose();
        console.log(error.response.data.message);
        alert(error?.response?.data?.message || "Avatar is currently in use");
      });
  };

  return (
    <Modal
      open={visible}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="w-full">
          <div className="mb-4 flex items-center">
            <div className="mr-2 text-2xl font-bold">Delete Avatar</div>
          </div>
          <p className="mb-6 tracking-wide">
            Do you really want to delete this Avatar?
          </p>
          <div className="flex justify-end space-x-4 tracking-wide">
            <button
              className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
              onClick={onClose}
            >
              Cancel
            </button>

            {isLoading ? (
              <button className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]">
                <BtnLoader />
              </button>
            ) : (
              <button
                onClick={deleteAvatar}
                className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]"
              >
                Yes, Delete
              </button>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmDeleteModal;







// import React, { useState } from "react";
// import Box from "@mui/material/Box";
// import Modal from "@mui/material/Modal";
// import axios from "axios";
// import BtnLoader from "Components/Common/Loader/BtnLoader";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "90%",
//   maxWidth: 400,
//   bgcolor: "background.paper",
//   border: "none",
//   borderRadius: 8,
//   boxShadow: 24,
//   p: 4,
// };

// const ConfirmDeleteModal = ({ visible, onClose, avatar, fetchAllAvatars }) => {
//   const [isLoading, setIsLoading] = useState(false);

//   const deleteAvatar = () => {
//     let config = {
//       method: "delete",
//       maxBodyLength: Infinity,
//       url: `${process.env.REACT_APP_API_URL}/avatar/delete-avatar/${avatar?._id}`,
//       headers: {},
//       data: "",
//     };

//     setIsLoading(true);
//     axios
//       .request(config)
//       .then((response) => {
//         setIsLoading(false);
//         fetchAllAvatars();
//         onClose();
//       })
//       .catch((error) => {
//         setIsLoading(false);
//         fetchAllAvatars();
//         onClose();
//         console.log(error.response.data.message);
//         alert(error?.response?.data?.message || "Avatar is currently in use");
//       });
//   };

//   return (
//     <Modal
//       open={visible}
//       onClose={onClose}
//       aria-labelledby="modal-modal-title"
//       aria-describedby="modal-modal-description"
//     >
//       <Box sx={style}>
//         <div className="w-full">
//           <div className="mb-4 flex items-center">
//             <div className="mr-2 text-2xl font-bold">Delete Avatar</div>
//           </div>
//           <p className="mb-6 tracking-wide">
//             Do you really want to delete this Avatar?
//           </p>
//           <div className="flex justify-end space-x-4 tracking-wide">
//             <button
//               className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
//               onClick={onClose}
//             >
//               Cancel
//             </button>

//             {isLoading ? (
//               <button className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]">
//                 <BtnLoader />
//               </button>
//             ) : (
//               <button
//                 onClick={deleteAvatar}
//                 className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]"
//               >
//                 Yes, Delete
//               </button>
//             )}
//           </div>
//         </div>
//       </Box>
//     </Modal>
//   );
// };

// export default ConfirmDeleteModal;
